import type { MiddlewareContext } from "@/router/index";

export default function middlewarePipeline(
  context: MiddlewareContext,
  middleware: any[],
  index: number,
): (parameters?: any) => Promise<void> {
  const nextMiddleware = middleware[index];

  // Если больше нет middleware, просто вызываем next
  if (!nextMiddleware) {
    return async () => {
      context.next();
    };
  }

  return async () => {
    // Создаем следующее звено в цепочке middleware
    const nextPipeline = middlewarePipeline(context, middleware, index + 1);

    // Выполняем текущее middleware и передаем следующую цепочку
    await nextMiddleware({ ...context, nextMiddleware: nextPipeline });
  };
}
